import React from 'react'

import {Game, Tournament} from '../types'

import GameUnit from './GameUnit'

import {useMeleeContext} from '../../draft/context/MeleeContextProvider'
import { useSearchParams } from 'react-router-dom'


const GamesTable = (props:{
    showCompletedGames:boolean,
    games?:Game[],
    tournamnet : Tournament
}) => { 
    let shownGamesCount = 0;

    const meleeContext = useMeleeContext();
    const [searchParams] = useSearchParams();

    let searchText = "";
    if(meleeContext && meleeContext.searchText)
        searchText = meleeContext.searchText

    const RenderGameUnits = () => {
        let shownGames = props.games;
        if(!shownGames) return  <h4>No Games found</h4>

        const words = searchText.split(' ');

        if(searchText){
            words.forEach((w) => {
                if(!shownGames) return
                shownGames = shownGames.filter((g) => (
                    g.Players.some((p) => 
                        p.Name.toLowerCase().toLowerCase().includes(w.toLowerCase())
                    )
                ));
            });
            shownGamesCount = shownGames.length;
        }

        if(shownGames.length === 0) return <h4>No Search Result</h4>
        return(
            shownGames.map((g) =>{ 
                if(!props.showCompletedGames && g.Winners.length > 0) return null;
                let isOpen = searchParams.get('open') === g.Id;
                return <GameUnit 
                    game={g} 
                    key={`game-row-${g.Id}`}
                    tournamnet={props.tournamnet}
                    showGameModal={isOpen}
                />
            }) 
        )
    }

    const footer = () => {
        let gamesCount = props.games ? props.games.length : 0;

        if(searchText && shownGamesCount > 0){
            return  <h5>{`Showing ${shownGamesCount}/${gamesCount} games`}</h5>
        }
    }
    
    return(
        <div style={{padding:'1em 0'}}>
              {RenderGameUnits()}
              {footer()}
        </div>
    )
}

export default GamesTable;